/**
 * Catálogo de tipos y subtipos de solicitud para configurar niveles de
 * autorización · alimenta los dropdowns del form de creación.
 *
 * Los `value` deben coincidir EXACTAMENTE con lo que usa el backend al
 * resolver el flujo: el tipo es el nombre del enum `TipoSolicitud`
 * (`s.Tipo.ToString()` → "FB60" / "ContratoAnualizado" / "OrdenDeCompra")
 * y el subtipo es la constante de `SubtipoSolicitud` ("CFDI_UNICO", …).
 *
 * Espejo de las listas `SubtipoSolicitud.SubtiposActivos*` del dominio
 * (`SolicitudesDePago.Domain.Solicitudes.SubtipoSolicitud`) — son las
 * combinaciones para las que una solicitud puede resolver flujo. Manténlo en
 * sincronía con esas listas del backend (mismo criterio que `lib/permisos.ts`).
 */
export interface OpcionSubtipo {
  value: string;
  label: string;
}

export interface OpcionTipo {
  value: string;
  label: string;
  subtipos: OpcionSubtipo[];
}

// Las etiquetas son los códigos crudos · consistente con las cards de grupos
// que muestran "FB60 / CFDI_UNICO".
export const TIPOS_SOLICITUD: OpcionTipo[] = [
  {
    value: "FB60",
    label: "FB60",
    subtipos: [
      { value: "CFDI_UNICO", label: "CFDI ÚNICO" },
      { value: "MULTIPLES_CFDI", label: "MULTIPLES CFDI" },
      { value: "CONTRAPAGO", label: "CONTRAPAGO" },
      { value: "INVOICE", label: "INVOICE" },
    ],
  },
  {
    value: "ContratoAnualizado",
    label: "CONTRATO ANUALIZADO",
    subtipos: [
      { value: "CFDI_UNICO", label: "CFDI ÚNICO" },
      { value: "MULTIPLES_CFDI", label: "MULTIPLES CFDI" },
      { value: "INVOICE", label: "INVOICE" },
    ],
  },
  {
    value: "OrdenDeCompra",
    label: "ORDEN DE COMPRA",
    subtipos: [
      { value: "CFDI_UNICO", label: "CFDI ÚNICO" },
      { value: "INVOICE", label: "INVOICE" },
    ],
  },
];

/** Devuelve los subtipos válidos para un tipo dado (vacío si no existe). */
export function subtiposDe(tipo: string): OpcionSubtipo[] {
  return TIPOS_SOLICITUD.find((t) => t.value === tipo)?.subtipos ?? [];
}
